// Mobile Messaging View - Imports desktop component in mobile-friendly wrapper
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { IntegratedMessaging } from '@/components/IntegratedMessagingDB';

export default function MessagingView() {
  const navigate = useNavigate();
  const { user } = useAuth();
  
  if (!user) {
    navigate('/login');
    return null;
  }
  
  const currentUser = { 
    id: user.id, 
    name: user.name || 'User', 
    email: user.email || '' 
  };

  // Render messaging in mobile-friendly full-screen mode
  return (
    <div className="fixed inset-0 z-50 bg-slate-900">
      <IntegratedMessaging
        currentUser={currentUser}
        onClose={() => navigate('/organizer')}
        isMinimized={false}
        onMinimize={() => {}}
      />
    </div>
  );
}
